import { Component, HostListener, NgZone, OnDestroy, OnInit, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { RoleServiceService } from '../../../utilities/services/role-service/role-service.service';

import { AuthServiceService } from '../../../utilities/services/auth-service/auth-service.service';
import { Router } from '@angular/router';
import { DashboardService } from '../../../utilities/services/dashboard-service/dashboard.service';
import { CommonServiceService } from '../../../utilities/services/common-service/common-service.service';
import { EncryptDecryptService } from '../../../utilities/services/EncrptyDecrypt/encrypt-decrypt.service';
import { DropdownModule } from 'primeng/dropdown';
import { OverlayModule } from '@angular/cdk/overlay';
import { environment } from '../../../../environments/environment';
import { Subject, takeUntil } from 'rxjs';
import { ThemeServiceService } from '../../../utilities/services/theme-service.service';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { readAuthProfileFlags } from '../../../utilities/auth-payload.util';
import {
  NON_PLAYER_PROFILE_ROUTE,
  PLAYER_PROFILE_ROUTE,
} from '../../../utilities/profile-route/profile-route.constants';
import {
  DEEP_LINK_REDIRECT_SOURCE,
  reloadAfterNavigation,
} from '../../../utilities/auth-session.util';
import { syncSentryUserFromStoredToken } from '../../../utilities/monitoring/sentry/sentry-user.util';
import {
  FORM_FIELD_TYPE_PASSWORD,
  isPasswordFieldType,
} from '../../../utilities/utils/security.util';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    OverlayModule,
    DropdownModule,
    TranslateModule,
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
  providers: [],
})
export class LoginComponent implements OnInit, OnDestroy {
  _selectedRole: any;
  _roles: any = [];
  _email: any = '';
  _password: any = null;
  all_roles: any = [];
  total_fields: any = []; // storing  fields who have access to login
  login_data: any = [];
  _formGroupDynamic: FormGroup = new FormGroup({});
  _isSubmit: boolean = false;
  durationInSeconds = 3000;
  is_password: boolean = false;
  input_type: string = FORM_FIELD_TYPE_PASSWORD;
  valid_form: boolean = true;
  logo: string = environment.logo;
  logo_dark: string = environment.logo_dark;
  logo_light: string = environment.logo_light;

  /** Light-theme logo in login sidebar; TTNZ uses `login_sidebar_logo_light` from env. */
  get loginSidebarLogoLight(): string {
    const env = environment as typeof environment & {
      login_sidebar_logo_light?: string;
    };
    if (env.tenant_Name === 'spain' || env.tenant_Name === 'ptta') {
      return env.logo;
    }
    return env.login_sidebar_logo_light ?? env.logo_dark;
  }


  password_field: {} = {
    role_id: 1,
    id: FORM_FIELD_TYPE_PASSWORD,
    is_login: true,
    is_required: true,
    is_deleted: false,
    updated_by: null,
    field_id: FORM_FIELD_TYPE_PASSWORD,
    field: {
      name: 'Password',
      id: FORM_FIELD_TYPE_PASSWORD,
      value_json: {},
      type: FORM_FIELD_TYPE_PASSWORD,
    },
  };
  isOpen = false;

  pasword_type_list = [
    { title: this.translateService.instant('app.passwordRequirementsLength') },
    {
      title: this.translateService.instant('app.passwordRequirementsLowercase'),
    },
    {
      title: this.translateService.instant('app.passwordRequirementsUppercase'),
    },
    {
      title: this.translateService.instant(
        'app.passwordRequirementsSpecialChar'
      ),
    },
  ];
  inputFocused: { [key: string]: boolean } = {};
  private readonly destroy$ = new Subject<void>();
  is_dark: boolean = false;
  innerHeight: any;
  @HostListener('window:resize')
  onResize() {
    if (globalThis.window !== undefined) {
      this.innerHeight = globalThis.window.innerHeight;
    }
  }

  show_sign_up: boolean = environment.show_sign_up;
  showAccountRestrictedDialog: boolean = false;
  restrictedMsg: string = '';
  restrictedReason: string = '';
  restrictedAdminEmail: string = '';
  footerSupportEmail: string = '';

  private resolveTenantName(): string {
    if (environment.tenant_Name === 'switz' || environment.tenant_Name === 'test_switz') {
      return 'switz';
    }
    return environment.tenant_Name;
  }

  tenant_name: string = this.resolveTenantName();
  constructor(
    private readonly cd: ChangeDetectorRef,
    private readonly zone: NgZone,

    private readonly role_service: RoleServiceService,
    private readonly fb: FormBuilder,
    private readonly authService: AuthServiceService,
    private readonly router: Router,
    private readonly dashboardService: DashboardService,
    private readonly encryptDecryptService: EncryptDecryptService,
    private readonly commonService: CommonServiceService,
    private readonly themeService: ThemeServiceService,
    private readonly translateService: TranslateService
  ) {
    // this.getRoles()
  }

  ngOnInit() {
    this.innerHeight = globalThis.window.innerHeight;
    // Subscribe to theme changes
    this.themeService.isDark$
      .pipe(takeUntil(this.destroy$))
      .subscribe((isDark: boolean) => {
        this.is_dark = isDark;
        this.cd.detectChanges();
      });

    // Initialize theme value
    this.is_dark = this.themeService.getTheme();

    this.commonService.getFooterConfig()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          this.footerSupportEmail = res?.data?.info_config?.email || '';
        },
        error: () => undefined,
      });

    this._formGroupDynamic = this.fb.group({});
    this.commonService.is_login_success
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: any) => {
        if (!res) {
          this.zone.run(() => {
            this._formGroupDynamic.reset();
            this._formGroupDynamic.markAsPristine();
            this._formGroupDynamic.markAsUntouched();
            Object.values(this._formGroupDynamic.controls).forEach((c) =>
              c.setErrors(null)
            );
            this._formGroupDynamic.updateValueAndValidity({ emitEvent: false });

            this.total_fields = [];
            this._selectedRole = null;
            this._isSubmit = false;
            this.all_roles = [];

            this.total_fields = [
              { id: 'identifier', is_required: true, field: { name: 'Email or ID', type: 'email' } },
              this.password_field,
            ];
            this.constrolsFormDynamically(this.total_fields);
            this.valid_form = false;

            this.cd.detectChanges();
          });
        }
      });
  }
  // Get Total roles
  getRoles(customParams: any = {}) {
    const {
      role_ids = 0,
      page_num = 0,
      per_page = 0,
      join_verifiers = false,
      join_parents = false,
      role_fields = false,
      is_active = true,
      is_login = false,
    } = customParams;
    this.role_service
      .getRoles(
        role_ids,
        page_num,
        per_page,
        join_verifiers,
        join_parents,
        role_fields,
        is_active,
        is_login
      )
      .subscribe({
        next: (req: any) => {
          if (req.code == 200) {
            this.all_roles = [];
            this.all_roles = req.data?.roles.filter((x: any) => x.is_active) ?? [];

            const playerRole = this.all_roles.find(
              (role: any) =>
                role?.name?.toLowerCase() === 'player' && role.is_active,
            );

            if (
              playerRole &&
              globalThis.window?.localStorage
            ) {
              localStorage.setItem('player_role_id', playerRole.id.toString());
            }
            if (this._formGroupDynamic == undefined) {
              this.valid_form = true;
            }
            if (playerRole && !this._selectedRole) {
              this._selectedRole = playerRole;
              this.GetRoleFieldsOnId({ value: playerRole });
            }
          }
        },
        error: (error) => {
          console.error('Error creating role', error);
        },
        complete: () => undefined,
      });
  }

  // get role felds based on Role Id
  GetRoleFieldsOnId(data: any) {
    const matchedRole = this.all_roles.find(
      (x: any) => x.id == data.value.id
    );
    if (!matchedRole) {
      return;
    }
    const fetched_role_id = matchedRole.id;
    const role_name = matchedRole.name;
    if (
      globalThis.window?.sessionStorage
    ) {
      sessionStorage.setItem('fetched_role_id', fetched_role_id.toString());
      sessionStorage.setItem('fetched_role_name', role_name);
    }
    this.role_service.getRoleFields(fetched_role_id).subscribe({
      next: (req: any) => {
        this.total_fields = [];
        if (req.code == 200) {
          this.total_fields = req.data.data[1];

          this.total_fields = this.total_fields.filter(
            (x: any) => x.is_login == true
          );
          if (this.total_fields.length > 0) {
            this.valid_form = false;
            this.total_fields.push(this.password_field);
          }
          this.total_fields = this.total_fields.map((x: any) => ({
            ...x,
            field: {
              ...x.field,
              type: x.field.type === 'string' ? 'text' : x.field.type,
            },
          }));
          if (
            globalThis.window?.sessionStorage
          ) {
            sessionStorage.setItem(
              'role_field_id',
              this.total_fields[0]?.id.toString()
            );
            this.constrolsFormDynamically(this.total_fields);
          }
        }
      },
      error: (error) => {
        console.error('Error creating role', error);
      },
    });
  }

  // set validation on fields
  setValidation(controlNames: any) {
    for (let item of controlNames) {
      if (item.field.type == 'text') {
        if (item.is_required) {
          this._formGroupDynamic.controls[item.id].setValidators(
            Validators.required
          );
          this._formGroupDynamic.controls[item.id].updateValueAndValidity();
        } else {
          this._formGroupDynamic.controls[item.id].setErrors(null);
          this._formGroupDynamic.controls[item.id].clearValidators();
          this._formGroupDynamic.controls[item.id].updateValueAndValidity();
        }
      } else if (item.field.type == 'email' || isPasswordFieldType(item.field.type)) {
        if (item.is_required) {
          this._formGroupDynamic.controls[item.id].setValidators(
            Validators.compose([
              Validators.required,
            ])
          );
          this._formGroupDynamic.controls[item.id].updateValueAndValidity();
        } else {
          this._formGroupDynamic.controls[item.id].setErrors(null);
          this._formGroupDynamic.controls[item.id].clearValidators();
          this._formGroupDynamic.controls[item.id].updateValueAndValidity();
        }
      }
    }
  }

  // login the user
  login() {
    this._isSubmit = true;
    if (!this._formGroupDynamic.valid) {
      return;
    }

    const identifierField = this.total_fields[0];
    this.login_data = {
      identifier: this._formGroupDynamic.controls[identifierField.id].value,
      password: this._formGroupDynamic.controls['password'].value,
    };
    this.authService
      .Login(this.login_data)
      .pipe()
      .subscribe({
        next: (res: any) => this.handleLoginResponse(res),
        error: () => undefined,
        complete: () => undefined,
      });
  }

  private handleLoginResponse(res: any): void {
    if (res.data.code == 200) {
      this.handleLoginSuccess(res);
      this.commonService.login_subject.next(false);
      return;
    }
    if (res.data.code == 403) {
      this.restrictedReason = res.data.data?.reason || '';
      this.showAccountRestrictedDialog = true;
      return;
    }
    this.openLoginSnackBar(res.data.msg, 'error');
  }

  private handleLoginSuccess(res: any): void {
    const responseData = JSON.parse(
      atob(res.data.data.access_token.split('.')[1]),
    );
    const { is_profile_completed: isProfileCompletedFromApi, is_verified: isVerifiedFromApi } =
      readAuthProfileFlags(res.data);

    this.openLoginSnackBar(
      this.translateService.instant('login_successful_with_role', {
        role: responseData.role_name,
      }),
      'success',
    );

    if (
      globalThis.window === undefined ||
      globalThis.localStorage === undefined
    ) {
      this.openLoginSnackBar(res.data.msg, 'error');
      return;
    }

    this.persistLoginSession(
      res,
      responseData,
      isProfileCompletedFromApi,
      isVerifiedFromApi,
    );
    this.commonService.is_login_success.next(true);
    syncSentryUserFromStoredToken();
    this.navigateAfterSuccessfulLogin(
      responseData,
      isProfileCompletedFromApi,
      isVerifiedFromApi,
    );
  }

  private persistLoginSession(
    res: any,
    responseData: any,
    isProfileCompletedFromApi: boolean,
    isVerifiedFromApi: boolean,
  ): void {
    localStorage.setItem('token', res.data.data.access_token);
    localStorage.setItem('webToken', res.data.data.access_token);
    localStorage.setItem(
      'role_id',
      this.encryptDecryptService.encryptUsingAES256(
        responseData.role_id.toString(),
      ),
    );
    localStorage.setItem(
      'user_role_id',
      this.encryptDecryptService.encryptUsingAES256(
        responseData.user_role_id.toString(),
      ),
    );
    localStorage.setItem(
      'login_field_value',
      this.encryptDecryptService.encryptUsingAES256(
        this.login_data.identifier,
      ),
    );
    localStorage.setItem(
      'is_profile_completed',
      String(isProfileCompletedFromApi),
    );
    localStorage.setItem('is_verified', String(isVerifiedFromApi));

    if (responseData?.role_name?.toString()?.toLowerCase() === 'player') {
      localStorage.setItem('player_role_id', responseData.role_id.toString());
    } else {
      localStorage.removeItem('player_role_id');
    }
  }

  private navigateAfterSuccessfulLogin(
    responseData: any,
    isProfileCompletedFromApi: boolean,
    isVerifiedFromApi: boolean,
  ): void {
    const redirectPath = sessionStorage.getItem('redirectAfterLogin');
    if (redirectPath) {
      this.navigateFromStoredRedirect(responseData, redirectPath);
      return;
    }

    const isPlayer = responseData?.role_name?.toString()?.toLowerCase() === 'player';
    const isProfileCompleted = isProfileCompletedFromApi === true;
    const isVerified = isVerifiedFromApi === true;

    if (!isProfileCompleted || !isVerified) {
      void this.router.navigate([
        isPlayer ? PLAYER_PROFILE_ROUTE : NON_PLAYER_PROFILE_ROUTE,
      ]);
      return;
    }

    reloadAfterNavigation(this.router.navigate(['/home']));
  }

  private navigateFromStoredRedirect(
    responseData: any,
    redirectPath: string,
  ): void {
    const redirectSource = sessionStorage.getItem('redirectSource');
    sessionStorage.removeItem('redirectAfterLogin');
    sessionStorage.removeItem('redirectSource');

    if (redirectSource === 'sub-license') {
      void this.router.navigate([redirectPath]);
      return;
    }
    if (redirectSource === 'order-payment' && redirectPath) {
      void this.router.navigateByUrl(redirectPath);
      return;
    }
    if (redirectSource === DEEP_LINK_REDIRECT_SOURCE) {
      reloadAfterNavigation(this.router.navigateByUrl(redirectPath));
      return;
    }

    const event_id = sessionStorage.getItem('event_id');
    if (responseData?.role_name?.toString()?.toLowerCase() === 'player') {
      reloadAfterNavigation(this.router.navigate([`events/register/${event_id}`]));
      return;
    }
    reloadAfterNavigation(this.router.navigate([`registration/${event_id}`]));
  }

  private openLoginSnackBar(message: string, panelClass: 'success' | 'error'): void {
    this.dashboardService.toast(message, panelClass, {
      duration: this.durationInSeconds,
      panelClass: ['mobile-toast'],
      verticalPosition: 'bottom',
      horizontalPosition: 'center',
    });
  }

  // creates form dynamically based on fields length
  constrolsFormDynamically(listOfFields: any) {
    const group: any = {};
    const simpleFieldTypes = new Set([
      'text',
      'number',
      'file',
      'email',
      'password',
      'dropdown',
      'date',
      'phone',
    ]);
    for (const item of listOfFields) {
      if (simpleFieldTypes.has(item.field.type)) {
        group[item.id] = new FormControl('', []);
      }
    }
    this._formGroupDynamic = new FormGroup(group);

    this.setValidation(listOfFields);
  }

  // toggling input type
  showPassword(type: any) {
    this.is_password = type === 'password';
    this.input_type = this.is_password ? 'text' : 'password';
  }

  //overlay on info icon for the password  requirement
  showOverlay() {
    this.isOpen = !this.isOpen;
  }
  closeDialog() {
    this.commonService.login_subject.next(false);
    if (typeof window !== 'undefined') {
      sessionStorage.removeItem('redirectAfterLogin');
      sessionStorage.removeItem('redirectSource');
    }
  }

  navigateToFrgt() {
    this.commonService.forgot_password_subject.next(true);
  }
  navigateToSignUp() {
    this.commonService.signup_subject.next(true);
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    this._selectedRole = null;
  }

  trackByFieldId(index: number, item: any): any {
    return item.id;
  }

  trackById(index: number, item: unknown): string | number {
    if (item != null && typeof item === 'object' && 'id' in item) {
      const id = (item as { id?: string | number }).id;
      if (id != null) return id;
    }
    return index;
  }
}
